import { useEffect } from "react";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Dashboard from "../Table/dashboard/Dashboard";
import User from "../Table/user/User";
import Setting from "../Table/setting/Setting";
import $ from "jquery";

import UserProfile from "../Table/user/UserProfile";
import Seller from "../Table/seller/Seller";
import AdminProfile from "../Table/admin/AdminProfile";
import SellerRequest from "../Table/sellerRequest/SellerRequest";
import SellerProfile from "../Table/seller/SellerProfile";
import AddSeller from "../Table/seller/AddSeller";
import Product from "../Table/Product/Product";
import ProductDetail from "../Table/Product/ProductDetail";
import Category from "../Table/category/Category";
// import Order from "../Table/Order/Order";
import Order from "../Table/Order/Order";
import OrderDetail from "../Table/Order/OrderDetail";
import PromoCode from "../Table/PromoCode/PromoCode";
import FaQ from "../Table/FAQ/Faq";
import Withdraw from "../Table/withdraw/Withdraw";
import Attribute from "../Table/Attribute/Attribute";
import CategoryWiseSubCategory from "../Table/subCategory/CategoryWiseSubCategory";
import PendingProduct from "../Table/Product/PendingProduct";
import ApprovedProduct from "../Table/Product/ApprovedProduct";
import RejectedProduct from "../Table/Product/RejectedProduct";
import AddProduct from "../Table/Product/AddProduct";
import PaymentSetting from "../Table/setting/paymentSetting";
import UpdateRequest from "../Table/Product/UpdateRequest";
import UpdateProducutApproved from "../Table/Product/UpdateProducutApproved";
import UpdateProductRejected from "../Table/Product/UpdateProductRejected";
import SellerOrderDetail from "../Table/seller/Profile/SellerOrderDetail";
import LiveSeller from "../Table/liveSeller/LiveSeller";
import LiveSellerProduct from "../Table/liveSeller/LiveSellerProduct";
// import EditSellerR from "../Table/sellerRequest/EditSellerR";
import EditSellerRequest from "../Table/sellerRequest/EditSellerRequest";
import FakeSeller from "../Table/fakeSeller/FakeSeller";
import Reels from "../Table/reels/Reels";
import FakeReels from "../Table/fakeReels/FakeReels";
import ReelsInfo from "../Table/fakeReels/ReelsInfo";
// import ReportedReels from "../Table/reels/ReportedReels";
import FakeSellerDialogue from "../Table/fakeSeller/FakeSellerDialogue";
import FakeProduct from "../Table/FakeProduct/FakeProduct";
import { useSelector } from "react-redux";
import BankSetting from "../Table/bank/BankSetting";
import CurrencySetting from "../Table/currencySetting/currencySetting";
import AdminEarning from "../Table/admin/AdminEarning";
import AdminWithdrawal from "../Table/AdminWithdrawal/AdminWithdrawal";
import ReportReason from "../Table/reportReason/ReportReason";
import VideoReport from "../Table/videoReport/VideoReport";
import Others from "../Table/other/Others";
import DeliveryService from "../Table/deliveryService/DeliveryService";
import Roles from "../Table/staff/Roles";
import Staff from "../Table/staff/Staff";
import Language from "../Table/language/Language";
import ProtectedRoute from "../../util/ProtectedRoute";
import { useDispatch } from "react-redux";
import { getAllLanguages } from "../store/language/language.action";
import NoLanguageModal from "../extra/NoLanguageModal";

export const token = sessionStorage.getItem("token");

const Admin = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { totalLanguages, isLoading } = useSelector((state) => state.language);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      location.pathname == "/" ||
      location.pathname == "/admin" ||
      location.pathname == "" ||
      location.pathname == "/admin/"
    ) {
      navigate("/admin/dashboard");
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    dispatch(getAllLanguages());
  }, [dispatch]);

  const isLanguagePage = location.pathname === "/admin/language";
  const showNoLanguageModal = !isLoading && totalLanguages === 0 && !isLanguagePage;

  useEffect(() => {
    $(document).ready(function () {
      $(".subMenu").hide();

      // Event delegation — works for both expanded and collapsed sidebar
      $(document).on("click.sidebarMenu", ".mainMenu > li > a", function (e) {
        const $subMenu = $(this).next(".subMenu");
        if (!$subMenu.length) return;

        e.preventDefault();

        if ($subMenu.is(":visible")) {
          $subMenu.slideUp();
          $(this).children("i.rightangel").removeClass("rotate90");
        } else {
          $(".subMenu").slideUp();
          $(".mainMenu > li > a").children("i.rightangel").removeClass("rotate90");
          $subMenu.slideDown();
          $(this).children("i.rightangel").addClass("rotate90");
        }
      });

      $(document).on("click.sidebarToggle", ".navToggle", function () {
        $(".mainNavbar").toggleClass("mobNav webNav");
        $(".sideBar").toggleClass("mobSidebar webSidebar");
        $(".mainAdmin").toggleClass("mobAdmin");
        $(".sidebar-overlay").toggleClass("show");

        $(".subMenu").slideUp(0);
        $(".mainMenu > li > a").children("i.rightangel").removeClass("rotate90");

        if ($(".sideBar").hasClass("webSidebar") && window.innerWidth > 992) {
          $(".subMenu").hide();
        }
      });
    });

    return () => {
      $(document).off("click.sidebarMenu");
      $(document).off("click.sidebarToggle");
    };
  }, []);

  return (
    <>
      <NoLanguageModal open={showNoLanguageModal} />
      <div className="mainContainer d-flex w-100">
        <div
          className="sidebar-overlay"
          onClick={() => {
            $(".mainNavbar").toggleClass("mobNav webNav");
            $(".sideBar").toggleClass("mobSidebar webSidebar");
            $(".mainAdmin").toggleClass("mobAdmin");
            $(".sidebar-overlay").toggleClass("show");
            $(".subMenu").slideUp(0);
            $(".mainMenu > li > a").children("i.rightangel").removeClass("rotate90");
          }}
        ></div>
        <div className="containerLeft">
          <Sidebar />
        </div>
        <div className="containerRight w-100">
          <Navbar />
          <div className="mainAdmin">
            <Routes>
              {/* dashboard */}
              <Route path="/dashboard" element={<Dashboard />} />

              {/* user */}
              <Route
                path="/user"
                element={
                  <ProtectedRoute module="User">
                    <User />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/UserProfile"
                element={
                  <ProtectedRoute module="User">
                    <UserProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sellerRequestEdit"
                element={
                  <ProtectedRoute module="Seller">
                    <EditSellerRequest />
                  </ProtectedRoute>
                }
              />

              {/* seller */}
              <Route
                path="/seller"
                element={
                  <ProtectedRoute module="Seller">
                    <Seller />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/fakeSeller"
                element={
                  <ProtectedRoute module="Seller">
                    <FakeSeller />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/addFakeSeller"
                element={
                  <ProtectedRoute module="Seller">
                    <FakeSellerDialogue />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/liveSeller"
                element={
                  <ProtectedRoute module="Live Seller">
                    <LiveSeller />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/liveSellerProduct"
                element={
                  <ProtectedRoute module="Live Seller">
                    <LiveSellerProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sellerProfile"
                element={
                  <ProtectedRoute module="Seller">
                    <SellerProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/addSeller"
                element={
                  <ProtectedRoute module="Seller">
                    <AddSeller />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sellerOrderDetail"
                element={
                  <ProtectedRoute module="Seller">
                    <SellerOrderDetail />
                  </ProtectedRoute>
                }
              />
              {/* seller Request */}
              <Route
                path="/sellerRequest"
                element={
                  <ProtectedRoute module="Seller">
                    <SellerRequest />
                  </ProtectedRoute>
                }
              />

              {/* staff management */}
              <Route
                path="/roles"
                element={
                  <ProtectedRoute module="Access Roles">
                    <Roles />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/staff"
                element={
                  <ProtectedRoute module="Staff">
                    <Staff />
                  </ProtectedRoute>
                }
              />

              {/* category  && subCategory */}
              <Route
                path="/category"
                element={
                  <ProtectedRoute module="Category">
                    <Category />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/category/subCategory"
                element={
                  <ProtectedRoute module="Category">
                    <CategoryWiseSubCategory />
                  </ProtectedRoute>
                }
              />

              {/* attributes */}
              <Route
                path="/attribute"
                element={
                  <ProtectedRoute module="Attribute">
                    <Attribute />
                  </ProtectedRoute>
                }
              />

              {/* Product */}
              <Route
                path="/product"
                element={
                  <ProtectedRoute module="Product">
                    <Product />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/addProduct"
                element={
                  <ProtectedRoute module="Product">
                    <AddProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/fake/addProduct"
                element={
                  <ProtectedRoute module="Product">
                    <AddProduct />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/productDetail"
                element={
                  <ProtectedRoute module="Product">
                    <ProductDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/fake/productDetail"
                element={
                  <ProtectedRoute module="Product">
                    <ProductDetail />
                  </ProtectedRoute>
                }
              />

              {/* Fake Product */}
              <Route
                path="/fakeProduct"
                element={
                  <ProtectedRoute module="Product">
                    <FakeProduct />
                  </ProtectedRoute>
                }
              />

              {/* video Report */}
              <Route
                path="/videoreport"
                element={
                  <ProtectedRoute module="Reels Report">
                    <VideoReport />
                  </ProtectedRoute>
                }
              />

              {/* create Product Request by App */}
              <Route
                path="/pendingProduct"
                element={
                  <ProtectedRoute module="Product Request">
                    <PendingProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/approvedProduct"
                element={
                  <ProtectedRoute module="Product Request">
                    <ApprovedProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rejectedProduct"
                element={
                  <ProtectedRoute module="Product Request">
                    <RejectedProduct />
                  </ProtectedRoute>
                }
              />

              {/* update Product Request by App */}

              <Route
                path="/pendingUpdateRequest"
                element={
                  <ProtectedRoute module="Product Request">
                    <UpdateRequest />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/approvedUpdateRequest"
                element={
                  <ProtectedRoute module="Product Request">
                    <UpdateProducutApproved />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rejectedUpdateRequest"
                element={
                  <ProtectedRoute module="Product Request">
                    <UpdateProductRejected />
                  </ProtectedRoute>
                }
              />

              {/* order */}
              <Route
                path="/order"
                element={
                  <ProtectedRoute module="Order">
                    <Order />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/order/orderDetail"
                element={
                  <ProtectedRoute module="Order">
                    <OrderDetail />
                  </ProtectedRoute>
                }
              />

              {/* promoCode */}
              <Route
                path="/promoCode"
                element={
                  <ProtectedRoute module="PromoCode">
                    <PromoCode />
                  </ProtectedRoute>
                }
              />

              {/* FaQ */}
              <Route
                path="/faq"
                element={
                  <ProtectedRoute module="FAQ">
                    <FaQ />
                  </ProtectedRoute>
                }
              />

              {/* Withdraw Methods*/}
              <Route
                path="/withDraw"
                element={
                  <ProtectedRoute module="Setting">
                    <Withdraw />
                  </ProtectedRoute>
                }
              />

              {/* Seller Withdraw */}
              {/* <Route path="/redeem" element={<Redeem />} /> */}

              {/* admin Profile */}
              <Route path="/profilePage" element={<AdminProfile />} />

              <Route
                path="/adminwithdrawal"
                element={
                  <ProtectedRoute module="Seller Withdrawal">
                    <AdminWithdrawal />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/wallet"
                element={
                  <ProtectedRoute module="Admin Earning">
                    <AdminEarning />
                  </ProtectedRoute>
                }
              />

              {/* setting */}
              <Route
                path="/setting"
                element={
                  <ProtectedRoute module="Setting">
                    <Setting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/currencySetting"
                element={
                  <ProtectedRoute module="Setting">
                    <CurrencySetting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/paymentSetting"
                element={
                  <ProtectedRoute module="Setting">
                    <PaymentSetting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/bankSetting"
                element={
                  <ProtectedRoute module="Setting">
                    <BankSetting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/deliveryService"
                element={
                  <ProtectedRoute module="Setting">
                    <DeliveryService />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reportreason"
                element={
                  <ProtectedRoute module="Report Reason">
                    <ReportReason />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/others"
                element={
                  <ProtectedRoute module="Setting">
                    <Others />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/language"
                element={
                  <ProtectedRoute module="App Language">
                    <Language />
                  </ProtectedRoute>
                }
              />

              {/* reels */}

              <Route
                path="/reels"
                element={
                  <ProtectedRoute module="Reels">
                    <Reels />
                  </ProtectedRoute>
                }
              />
              {/* <Route path="/reportedReels" element={<ReportedReels />} /> */}

              <Route
                path="/fake/reels/details"
                element={
                  <ProtectedRoute module="Reels">
                    <ReelsInfo />
                  </ProtectedRoute>
                }
              />

              {/* fake reels */}

              <Route
                path="/fakeReels"
                element={
                  <ProtectedRoute module="Reels">
                    <FakeReels />
                  </ProtectedRoute>
                }
              />
            </Routes>

          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
